<template>
  <h3>Наилучшие Оценки</h3>
  <div class="block">
    <h5>Расчеты по РУ</h5>
    <p>При загрузке треугольника по РУ, исходным методом расчета является метод «ЦЛ». Также, доступны другие методы для расчета, которые можно выбрать с помощью фильтра «Метод расчета»:</p>
    <img src="@/assets/img/guide/add-method.png" alt="" srcset="">
  </div>
  <div class="block">
    <h5>Расчеты по РРУУ</h5>
    <p>Для расчета наилучших оценок по РРУУ <b>необязательно</b> загружать инкрементальные треугольники по всем сущностям. При первой загрузке «Резерва убытков» расчеты по наилучшим оценкам РРУУ формируются автоматически с использованием метода «Доля от резерва»:</p>
    <img src="@/assets/img/guide/calculation-header.png" alt="" srcset="">
    <p>В данном случае нужно заполнить фильтры: «Доля РУУ в РЗНУ, %» и «Доля РУУ в РПНУ, %».</p>
    <p>Дополнительно есть возможность загрузить треугольники развития по трем видам РУУ:</p>
    <ul>
      <li>РРУУ прямые</li>
      <li>РРУУ судебные</li>
      <li>РРУУ (ПВУ)</li>
    </ul>
    <p>Если пользователь загружаете треугольники по какому-либо из видов РУУ, 
      то расчеты по соответствующему РРУУ формируются с использованием исходного метода «Цепная лестница». 
      Дополнительно можно оценить РРУУ методом «Борнхьюттера-Фергюссона».</p>
    <p>В случае проведения расчета Резерва убытков методом «Частота и среднее» в РРУУ можно добавить оценку методом «По среднему РУУ», 
      где используется количество убытков из метода «Частота и среднее» для РУ.</p>
  </div>
  <div class="block">
    <h5>Расчеты по ожидаемым ГОТС, Регрессам, разницам по РСА и Резерву Нулевых требований</h5>
    <p>Для расчетов наилучших оценок по данным сущностям, исходным методом является метод «ЦЛ». Также, доступны следующие методы расчетов: Борнхьюттера-Фергюссона и простая убыточность.</p>
  </div>
  <div class="block">
    <h5>Взаимодействие с интерфейсом</h5>
    <p>Для расчета наилучших оценок по всем сущностям, необходимо нажать на кнопку «Рассчитать».</p>
  </div>
  <div class="block">
    <h5>Взаимодействие с интерфейсом в методе ЦЛ</h5>
    <p>Для расчетов наилучших оценках в методе «ЦЛ» доступны две персонализации расчета.</p>
    <ul>
      <li>
        <b>Индивидуальные коэффициенты развития</b> 
        <br>
        Пользователь может убрать выбросы в таблице «Индивидуальные коэффициенты развития». 
        Для этого необходимо нажать на коэффициенты, которые необходимо убрать. 
        Выбранные коэффициенты, которые не будут использоваться в расчете, будут выделены серым:
      </li>
      <img src="@/assets/img/guide/development-coefficients-grey.png" width="400" alt="" srcset="">
      <li>
        <b>Выбор коэффициентов развития</b> 
        <br>
        Пользователь может выбрать разные итоговые коэффициенты развития или указать свои коэффициенты используя поле «Задан вручную» в таблице 
        «Выбор коэффициентов развития». Выбор коэффициентов производится нажатием мышкой на нужные Вам коэффициенты.
        <img src="@/assets/img/guide/development-coefficients-blue.png" width="400" alt="" srcset="">
      </li>
    </ul>
  </div>
  <div class="block">
    <h5>Взаимодействие с интерфейсом в методе Борнхьюттера-Фергюссона (БФ)</h5>
    <p>Помимо указанной персонализации в методе «ЦЛ», метод БФ включает в себя еще две персонализации, касающиеся коэффициентов убыточности.</p>
    <ul>
      <li>
        <b>Коэффициенты убыточности – Исключение выбросов</b> 
        <br>
          Также, как и в методе «ЦЛ», можно исключить выбросы в коэффициентах убыточности.
      </li>
      <img src="@/assets/img/guide/development-coefficients-grey.png" width="400" alt="" srcset="">
      <li>
        <b>Коэффициенты убыточности – Выбор итоговой убыточности</b> 
        <br>
          Пользователь также может выбрать итоговые значения для коэффициентов убыточности.
        <img src="@/assets/img/guide/development-coefficients-blue.png" width="400" alt="" srcset="">
      </li>
    </ul>
  </div>
</template>
  
<script>
export default {
  name: 'BestEstimates',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
